<template>
  <div style="z-index: 11;">
    <button
      class="uk-button uk-button-default uk-border-pill uk-button-small uk-margin-small-right uk-flex uk-flex-middle"
      @click.prevent="open"
    >
      <span class="uk-margin-small-right uk-icon" uk-icon="icon: history; ratio: 0.8"></span>
      Warenkorb Historie
    </button>
    <Modal ref="modal" large>
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <div class="uk-modal-header">
        <h3 class="uk-modal-title">Warenkorb Historie für Fahrzeug {{ history[0].carId }}</h3>
      </div>
      <div class="uk-modal-body uk-padding-remove-horizontal" uk-overflow-auto>
        <table class="uk-table uk-table-middle uk-table-small uk-table-striped uk-table-hover uk-table-divider">
          <thead>
            <tr>
              <th class="uk-table-expand">Händler</th>
              <th class="uk-width-auto uk-text-right"></th>
              <th class="uk-text-nowrap uk-text-right" style="width: 180px">Hinzugefügt am</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in history" :key="i">
              <td>
                {{ item.merchant.company }}
              </td>
              <td class="uk-text-right">
                <span class="uk-label uk-label-success" v-if="i === 0 && currentlyInCart">Aktuell im Warenkorb</span>
              </td>
              <td class="uk-text-right">
                {{ item.createdAt }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from '../Modal.vue'
export default {
  props: {
    history: {
      required: true
    },
    currentlyInCart: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    }
  },
  components: { Modal }
}
</script>
